"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskTypeRendererFactory = void 0;
const TaskType_1 = require("@opsbase/lib-task/TaskType");
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const get_1 = __importDefault(require("lodash/get"));
const react_1 = __importDefault(require("react"));
const TaskTypeRendererFactory = (viewField) => (task) => {
    let value = (0, get_1.default)(task, viewField.propertyName);
    if (!value)
        return null;
    return react_1.default.createElement(Text_1.default, null, (0, TaskType_1.taskTypeLabel)(value));
};
exports.TaskTypeRendererFactory = TaskTypeRendererFactory;
exports.default = exports.TaskTypeRendererFactory;
